import { clsx, type ClassValue } from 'clsx'
import { isEmpty, isNil, merge } from 'lodash-es'
import { twMerge } from 'tailwind-merge'
import { isArray, isBoolean, isNumber, isString } from 'util'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Funzione per determinare se un valore è falsy
 * @param value Valore da controllare
 * @returns true se il valore è falsy, false altrimenti
 */
export const isFalsy = (value: any): boolean => {
  if (isNil(value)) return true
  if (isString(value) && value.trim() === '') return true
  if (isNumber(value) && value === 0) return true
  if (isBoolean(value) && value === false) return true
  if (isArray(value) && isEmpty(value)) return true
  if (typeof value === 'object' && isEmpty(value)) return true
  return false
}

/**
 * Funzione per unire oggetti sovrascrivendo solo i valori falsy
 * @param target Oggetto target
 * @param source Oggetto sorgente
 * @returns Oggetto risultante
 */
export const mergeOnlyFalsy = (target: any, source: any = {}): any => {
  // Se entrambi sono array, restituisci source se target è falsy o vuoto, altrimenti target
  if (Array.isArray(target) && Array.isArray(source)) {
    return isFalsy(target) ? source : target
  }

  // Crea una copia profonda dell'oggetto target
  const result = merge({}, target || {})

  // Itera su tutte le chiavi dell'oggetto sorgente
  Object.keys(source || {}).forEach(key => {
    // Se la chiave non esiste nel target o il valore nel target è falsy, sovrascrivi
    if (!(key in target) || isFalsy(target[key])) {
      result[key] = source[key]
    } else if (
      typeof source[key] === 'object' &&
      source[key] !== null &&
      typeof target[key] === 'object' &&
      target[key] !== null
    ) {
      // Se entrambi sono oggetti, applica ricorsivamente
      result[key] = mergeOnlyFalsy(target[key], source[key])
    }
  })

  return result
}
